module.exports = __webpack_public_path__ + "static/media/26UNRWA20.39a6f8db.jpg";